export default __webpack_public_path__ + "static/hero-tasmania-ab53b06d0aad06fd18a92a38ff5f2f76.jpg";